<template>
  <div class="sd-kpi" :class="{gold}">
    <div class="glow" />
    <div class="top"><span class="lbl">{{ label }}</span><span class="ic"><v-icon>{{ icon }}</v-icon></span></div>
    <div class="v" :style="color ? {color} : null">
      <slot><span class="num-ltr">{{ value }}</span><small v-if="unit">{{ unit }}</small></slot>
    </div>
    <div v-if="spark && spark.length > 1" class="kspark"><sd-spark-line :values="spark" :color="sparkColor" /></div>
    <div v-if="delta != null || footnote" class="ft">
      <sd-delta-chip v-if="delta != null" :d="delta" :unit="deltaUnit" />
      <span v-if="footnote" v-html="footnote" />
    </div>
  </div>
</template>
<script>
import SdSparkLine from './charts/SparkLine.vue'
import SdDeltaChip from './DeltaChip.vue'
export default {
  name: 'SdKpiCard',
  components: { SdSparkLine, SdDeltaChip },
  props: {
    label: String, icon: { type: String, default: 'mdi-chart-box-outline' }, value: [String, Number], unit: String, color: String,
    gold: Boolean, spark: Array, sparkColor: { type: String, default: 'var(--sd-green-500)' }, delta: { type: Number, default: null }, deltaUnit: String, footnote: String,
  },
}
</script>
